angular.module("goodInstallationAddress.components", []).component("goodInstallationAddress", {
    templateUrl: "ng/components/changeGoodAddress/goodInstallationAddress/goodInstallationAddress.view.html",
    bindings: {
        richiestePostVendita: "=",
        validatePage: "&"
    },
    controllerAs: "goodInstallationAddressCtrl",
    controller: function GoodInstallationAddress(
        $timeout,
        $arcService,
        Sede,
        DettaglioImmobiliare
    ) {
        var self = this;

        self.appContract = {
            numeroContratto: null,
            modulo: null,
            cdBeni: []
        }

        self.contratti = [];
        self.dettaglioList = [];

        self.$onInit = function () {
            self.numberContractSelected = 1;
            self.init = true;
            self.supportModel = {
                contractSelected: [],
                contractList: [],
                listToUpdate: [],
                newAddress: Sede.build()
            }

            if (typeof self.richiestePostVendita.metadata.variazioneAnagrafica.dettaglioBeni.proprietario == "undefined" ||
                self.richiestePostVendita.metadata.variazioneAnagrafica.dettaglioBeni.proprietario == null) {
                self.richiestePostVendita.metadata.variazioneAnagrafica.dettaglioBeni.proprietario = true;
            }

            self.supportModel.variazioneAnagrafica = self.richiestePostVendita.metadata.variazioneAnagrafica;
            self.supportModel.listToUpdate = self.supportModel.variazioneAnagrafica.contratti;
            self.supportModel.newAddress = self.supportModel.variazioneAnagrafica.sedeConsegna;

            self.supportModel.listToUpdate.forEach(function (element) {
                if (element.dettaglioImmobiliare.length) {
                    element.selected = true;
                    self.dettaglioList = element.dettaglioImmobiliare;
                }
            });
            self.getElencoBeni();
            checkValidityPage();
        };

        self.exportValiditySede = function (validity) {
            self.validitySede = validity;
        }

        self.exportValidityNewSede = function (validity) {
            self.validityNewSede = validity;
            checkValidityPage();
        }

        self.handleChange = function (property, value) {
            switch (property) {
                case "newAddress":
                    self.supportModel.variazioneAnagrafica.sedeConsegna = value;
                    break;
                case "proprietario":
                case "cfPiva":
                case "ragSocNominativo":
                case "indirizzo":
                    self.supportModel.variazioneAnagrafica.dettaglioBeni[property] = value;
                    break;
                default:
                    self.supportModel.variazioneAnagrafica[property] = value;
                    break;
            }
            checkValidityPage();
        }

        var checkValidityPage = function () {

            var testContratto = false;
            self.supportModel.variazioneAnagrafica.contratti.some(function (element) {
                if (element.dettaglioImmobiliare.length) {
                    element.dettaglioImmobiliare.some(function (element) {
                        if (element.selected) {
                            testContratto = true;
                            return;
                        }
                    })
                } else {
                    return false;
                }
            })

            var proprietarioImm = false;
            if (!self.supportModel.variazioneAnagrafica.dettaglioBeni.proprietario) {
                proprietarioImm = self.supportModel.variazioneAnagrafica.dettaglioBeni.cfPiva &&
                    self.supportModel.variazioneAnagrafica.dettaglioBeni.ragSocNominativo && self.validityNewSede
            } else {
                proprietarioImm = true;
            }

            if (self.validitySede && testContratto && proprietarioImm &&
                self.supportModel.variazioneAnagrafica.motivazione) {
                self.validatePage({
                    validity: true
                });

                self.richiestePostVendita.metadata.variazioneAnagrafica = self.supportModel.variazioneAnagrafica;

            } else {
                self.validatePage({
                    validity: false
                });
            }
        }

        self.getElencoBeni = function () {
            self.isPending = true;

            self.supportModel.listToUpdate.forEach(function (contratto, index) {
                var pendingElement = [];
                $timeout(function () {
                    pendingElement[index] = true;
                    self.appContract.numeroContratto = contratto.numero;
                    self.appContract.modulo = contratto.modulo;
                    self.appContract.cdBeni = [contratto.codProdotto];

                    $arcService
                        .getElencoBeni(self.appContract)
                        .then(function (response) {
                            response.forEach(function (element) {
                                var dettaglio = DettaglioImmobiliare.build();
                                dettaglio.numero = contratto.numero;
                                dettaglio.modulo = contratto.modulo;
                                dettaglio.indirizzo = Sede.build(element.indirizzo);
                                dettaglio.indirizzo.luogoEsteso.nome = element.indirizzo.comune;
                                dettaglio.descrizione = element.descrizione;
                                dettaglio.selected = true;
                                dettaglio.codiceBene = element.codiceBene;
                                contratto.dettaglioImmobiliare.push(dettaglio);
                                removeDupliDettaglio(contratto.dettaglioImmobiliare)
                            });


                            pendingElement[index] = false;
                            self.isPending = !pendingElement.every(function (element) {
                                return element == false
                            });
                        })
                        .catch(function (error) {
                            console.log("ERROR:", error)
                            self.isPending = false;
                        })

                }, 1000);
            });

            checkValidityPage();
        }

        var removeDupliDettaglio = function (dettaglioImmobiliare) {
            var contrattoDettImmobiliare = dettaglioImmobiliare.filter(function (detail, index) {
                var ind = dettaglioImmobiliare.findIndex(function (otherDetail) {
                    return detail.codiceBene == otherDetail.codiceBene
                })
                if (index == ind) {
                    return detail;
                }
            })
            self.dettaglioList = contrattoDettImmobiliare;
        }
    }
});